import React, { useState } from 'react'
import injectSheet from 'react-jss'
import styles from './examples-entry.styles'
// import CircleStatus from 'pobble-components/dist/circle-status'
import { Link } from 'react-router-dom'
// import ContextMenu from './context-menu/context-menu.container'
import Button from 'pobble-components/dist/button'
//import AgeGroup from 'pobble-components/dist/age-group'
import ArrowIcon from 'react-icons/lib/fa/arrow-right'
import InfoIcon from 'react-icons/lib/fa/info-circle'
import { SubsCrown } from 'pobble-components/dist/subscriptions'
import { useSubscriptionPolicy } from 'pobble-components/dist/subscriptions'
import { UpsellModal } from '../../../../../upsell/upsell'
import classNames from 'classnames'
import CopyIcon from 'react-icons/lib/fa/copy'
import Tooltip from 'pobble-components/dist/tooltip'
import { useMe } from 'pobble-components/dist/pobble-user'

const ExamplesEntry = ({
  classes,
  id,
  fileId,
  title,
  conclusion,
  createdAt,
  pending,
  link,
  student,
  thumb,
  author,
  ageGroupOrder,
  ageGroupTitle,
  judgement,
  premium,
  onCopy
}) => {
  const examplificationSp = useSubscriptionPolicy(
    sp => sp.moderation.examplification_material
  )
  const [upsellModalOpen, setUpsellModalOpen] = useState(false)
  const { me, showSchoolRequiredDialog } = useMe()
  const hasSchool = me.account.policy.teacher_in_school

  return (
    <div className={classes.container} pending={pending}>
      <Link
        className={classes.link}
        to={premium && examplificationSp.restricted ? '#' : link}
        onClick={e => {
          if (premium && examplificationSp.restricted) {
            e.preventDefault()
            setUpsellModalOpen(true)
          }
        }}>
        <div
          className={classNames(
            classes.thumb,
            classes['order' + ageGroupOrder]
          )}>
          {premium && <SubsCrown className={classes.crown} accent />}
          <div className={classes.book}>
            <div className={classes.bookTitle}>{title}</div>
            <div className={classes.bookArrow}>
              <ArrowIcon className={classes[judgement]} />
            </div>
            {/*<div className={classes.bookAuthor}>{author}</div>*/}
          </div>
        </div>
      </Link>
      {/*<h4 className={classes.title}>{title}</h4>
      <div>{author}</div>
      <div>{createdAt}</div>*/}
      {!examplificationSp.restricted && (
        <Button
          alignCenter
          icon={<CopyIcon />}
          className={classes.copyBtn}
          action={() =>
            hasSchool ? onCopy(fileId) : showSchoolRequiredDialog()
          }>
          Copy file
        </Button>
      )}
      {examplificationSp.restricted && (
        <Button
          alignCenter
          icon={<SubsCrown accent />}
          className={classes.copyBtn}
          action={() => setUpsellModalOpen(true)}>
          Copy file
        </Button>
      )}
      <Tooltip
        content={
          'Copy this file to use as a neutral evidence collection in your own school. The new copy made will appear in ‘My files’'
        }>
        <InfoIcon className={classes.info} />
      </Tooltip>
      {/*<ContextMenu id={id} />*/}
      {/*
      <AgeGroup order={ageGroupOrder}>{ageGroupTitle}</AgeGroup>

    */}
      <UpsellModal
        id="assesment-file"
        isOpen={upsellModalOpen}
        requestClose={() => setUpsellModalOpen(false)}
      />
    </div>
  )
}

export default injectSheet(styles)(ExamplesEntry)
